import React from 'react';
import DocumentList from '../components/DocumentList';

export default function PurchaseOrdersList() {
  return (
    <DocumentList
      apiPath="purchase-orders"
      numberField="po_number"
      title="Purchase Orders"
      createPath="/create-purchase-order"
      viewPath="/purchase-order"
      editPath="/edit-purchase-order"
    />
  );
}
